import Requester from '../Requester';

const sendOtp = (phoneNumber) => {
    return Requester.makeRequest(Requester.methods.GET, "auth/send/otp/" + phoneNumber)
};

const verifyOtp = (data) => {
    return Requester.makeRequest(Requester.methods.POST, "auth/verify/otp", "", data)
};

const userLoginIn = (data) => {
    return Requester.makeRequest(Requester.methods.POST, "auth/login", "", data)
};

const loginWithoutOTP = (data) => {
    return Requester.makeRequest(Requester.methods.POST, "auth/signin", "", data)
};

const signUp = (data) => {
    return Requester.makeRequest(Requester.methods.POST, "auth/register", "", data)
};

export default {
    sendOtp: sendOtp,
    verifyOtp: verifyOtp,
    userLoginIn: userLoginIn,
    userLoginWithoutOTP: loginWithoutOTP,
    signUp: signUp
}
